import { WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise/model'
import { SET_DATA_KEY } from '../../../../workout-exercise/model/constants'
import getRoundsWorkoutSectionUtil from '../../../model/utils/get-rounds'
import getWorkoutExercisesWorkoutSectionUtil from '../../../model/utils/get-workout-exercises'

import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import updateWorkoutExerciseAction from '../../../../workout-exercise/redux/actions/update'
import WORKOUT_EXERCISES_PATH from '../../../../workout-exercise/redux/constants/path'
import { updateCurrentRoundIndexWorkoutExerciseAction } from '../update-current-round-index'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import getCurrentWorkoutSectionSelect from '../../selectors/get-current'
import updateDataWorkoutAction from '../../../../workout/redux/actions/update-data'
import { getObjectUtil, lastArrayUtil } from 'packages/src'

function addRoundWorkoutSectionAction () {
  return (dispatch, getState) => {
    const workoutSection = getCurrentWorkoutSectionSelect(getState())
    const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(workoutSection)
    const workoutExercisesDomainMap = getObjectUtil(
      getState(),
      WORKOUT_EXERCISES_PATH.DATA
    )
    const workoutExercises = workoutExercisePointers.map(pointer => (
      workoutExercisesDomainMap[getIdReduxUtil(pointer)]
    ))
    const rounds = getRoundsWorkoutSectionUtil(workoutExercises)
    if (!rounds.length) {
      return
    }
    const updates = []
    const workoutExercisesToUpdate = []
    const lastRound = lastArrayUtil(rounds)
    lastRound.forEach(roundSet => {
      const workoutExercise = workoutExercisesDomainMap[roundSet.workoutExerciseId]
      let setData = getValueReduxUtil(workoutExercise,
        WORKOUT_EXERCISE_KEY.SET_DATA
      )

      const newSets = []
      if (roundSet.set[SET_DATA_KEY.REST]) {
        const previousRoundSet = setData[roundSet.setIndex - 1]
        if (previousRoundSet && !previousRoundSet[SET_DATA_KEY.REST]) {
          newSets.push({ ...previousRoundSet })
        }
      }

      newSets.push({ ...roundSet.set })
      setData = [
        ...setData,
        ...newSets
      ]
      updates.push({ setData })
      workoutExercisesToUpdate.push(workoutExercise)
    })

    workoutExercisesToUpdate.forEach((workoutExerciseToUpdate, index) => {
      dispatch(updateWorkoutExerciseAction({
        type: WORKOUT_SECTIONS_ACTION.ADD_ROUND,
        payload: {
          workoutExercise: workoutExerciseToUpdate,
          updates: updates[index]
        }
      }))
    })

    dispatch(updateCurrentRoundIndexWorkoutExerciseAction(rounds.length))
    // Update the workout's data
    dispatch(updateDataWorkoutAction())
  }
}

export default addRoundWorkoutSectionAction
